import React from "react";
import Flash from "./Flash.jsx";
import CopyButton from "./CopyButton.jsx";
class WorkspaceSettings extends React.Component {
  constructor(props){
    super(props);
    this.state = {
        workspace: {},
        name_valid: true,
        name_changed: false,
        reveal_secret_key: false,
        flash_messages: [],
        flash_timestamp: "",
        updating: false,
        reveal_auth_key: false
    };

    this.retrieve_workspace = this.retrieve_workspace.bind(this);
    this.key_errors = this.key_errors.bind(this);
    this.save_workspace = this.save_workspace.bind(this);
    this.check_field_validity = this.check_field_validity.bind(this);

    this.VALID_NAME_REGEX = /^(?=.{5,40}$)\S(?:.*\S)?$/;

  }

  componentDidMount(){
    this.retrieve_workspace();
  }

  retrieve_workspace(){
    if (!this.props.id){
        return null;
    }
    fetch(`/workspaces/${this.props.id}?include=gateway_secret_key,auth_key`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'/*,
        'x-csrf-token': this.props.auth_token*/
      }/*,
      body: JSON.stringify({
        account: this.state.account
      })*/
    }).then((response) => {
      return response.json();
    }).then((json) => {
        this.setState({
            workspace: json.workspace
        });
    })
  }

  check_field_validity(){
    let errors = [];
    ['gateway_secret_key','gateway_publishable_key'].forEach(
        (field) => {
            errors = errors.concat(this.key_errors(field, this.state.workspace[field]));
        }
    );
    if (errors.length > 0){
        Flash.add_message(this, `The following errors were found: ${errors.join(',')}`, 'danger', 5);
        return false;
    }
    return true;
  }

  save_workspace(limited_fields){
    if (this.state.updating){
        return null;
    }
    if (!this.check_field_validity()){
        return false;
    }
    this.setState({
        updating: true
    });
    let fields;
    if (limited_fields){
        fields = limited_fields;
    } else {
        fields = ['gateway_secret_key','gateway_publishable_key','name'];
    }
    let workspace = {};
    Object.keys(this.state.workspace).map(
        (k) => {
            if (fields.includes(k)){
                workspace[k] = this.state.workspace[k];
            }
        }
    );
    fetch('/workspaces/'+this.state.workspace.id, {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-csrf-token': this.props.auth_token
      },
      body: JSON.stringify({
        workspace: workspace
      })
    }).then((response) => {
      return response.json();
    }).then((json) => {
        if (json.workspace){
            Flash.add_message(this, "Successfully updated.", 'success', 5);
        } else {
            Flash.add_message(this, "Failed to update", 'danger', 5);
        }
        this.setState({
            updating: false,
            name_changed: false
        });
    })
  }

  key_errors(field, value){
    if (field === 'gateway_secret_key'){
        if (value.slice(0,3) != 'sk_'){
            return ["The secret key given is not a valid secret ket"];
        }
    } else if (field === 'gateway_publishable_key'){
        if (value.slice(0,3) != 'pk_'){
            return ["The publishable key given is not a valid publishable key"];
        }
    }
    if (this.state.workspace.test_workspace && !value.includes('_test_')){
        return ["Invalid test key for this test Workspace"];
    } else if (!this.state.workspace.test_workspace && !value.includes('_live_')){
        return ["Invalid live key for this live Workspace"];
    }
    return [];
  }

  update_field(field, value){
    /*if (['gateway_secret_key','gateway_publishable_key'].includes(field)){
        if (this.key_is_ok(field, value)){
            return this.setState({});
        }
    }*/
  }

  render () {
    console.log(this.state);
    return (
        <div className="psintegril-card">
            <Flash messages={this.state.flash_messages} timestamp={this.state.flash_timestamp} on_update={(flash_state) => this.setState(flash_state)} />
            <h1>Workspace settings</h1>
            <h2>Workspace name</h2>
            <label className="psintegril-label">
                <span>Name</span>
                <input
                    className="psintegril-input"
                    type="text"
                    onChange={(e) => {
                        let workspace = this.state.workspace;
                        workspace.name = e.target.value;
                        this.setState({
                            workspace: workspace,
                            name_valid: this.VALID_NAME_REGEX.test(e.target.value),
                            name_changed: true
                        });
                    }}
                    value={this.state.workspace.name}
                />
            </label>
            {this.state.name_valid && this.state.name_changed ? 
                <button className="psintegril-btn psintegril-btn-primary" onClick={() => this.save_workspace(['name'])}>
                    Update
                </button> : null}
            <br />
            <h2>Auth key</h2>
            <label className="psintegril-label">
                <span>Auth key</span>
                <input
                    className="psintegril-input"
                    type={this.state.reveal_auth_key ? "text" : "password"}
                    value={this.state.workspace.auth_key}
                />
            </label>
            <button className="psintegril-btn psintegril-btn-secondary" onClick={() => this.setState({reveal_auth_key: !this.state.reveal_auth_key})}>
                {this.state.reveal_auth_key ? "Hide" : "Reveal"}
            </button>
            <CopyButton value={this.state.workspace.auth_key} />
            <br />
            <button className="psintegril-btn psintegril-btn-secondary">
                Rotate Key
            </button>
            <br /><br />
            <h2>Stripe settings</h2>
            <label className="psintegril-label">
                <span>Stripe secret key</span>
                <input
                    className="psintegril-input"
                    type={this.state.reveal_secret_key ? "text" : "password"}
                    onChange={(e) => {
                        let workspace = this.state.workspace;
                        workspace.gateway_secret_key = e.target.value;
                        this.setState({
                            workspace: workspace
                        });
                    }}
                    value={this.state.workspace.gateway_secret_key}
                />
            </label>
            {!this.state.workspace.gateway_secret_key || this.state.workspace.gateway_secret_key.length > 0 ? 
                <button className="psintegril-btn psintegril-btn-secondary" onClick={() => this.setState({reveal_secret_key: !this.state.reveal_secret_key})}>
                    {this.state.reveal_secret_key ? "Hide" : "Reveal"}
                </button> : null}<br /><br />
            <label className="psintegril-label">
                <span>Stripe publishable key</span>
                <input
                    className="psintegril-input"
                    type="text"
                    onChange={(e) => {
                        let workspace = this.state.workspace;
                        workspace.gateway_publishable_key = e.target.value;
                        this.setState({
                            workspace: workspace
                        });
                    }}
                    value={this.state.workspace.gateway_publishable_key}
                />
            </label>
            {/*<h2>General settings</h2>*/}
            <br />
            <button className="psintegril-btn psintegril-btn-primary" onClick={this.save_workspace}>
                {this.state.updating ? "Updating" : "Update"}
            </button>
        </div>
    );
  }
}

export default WorkspaceSettings;
